import { render, staticRenderFns } from "./CommentComponent.vue?vue&type=template&id=e89f6a7e&"
import script from "./CommentComponent.vue?vue&type=script&lang=ts&"
export * from "./CommentComponent.vue?vue&type=script&lang=ts&"
import style0 from "./CommentComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports